module.exports = __webpack_public_path__ + "static/media/email.af6134f2.svg";